{
  "removeButtonLabel": "Noņemt",
  "removeDescription": "Nospiediet Delete [Dzēst], lai noņemtu tagu."
}
